import ApiActions from 'api_actions';

export const SET_PROMO_CODES_LOADING = 'SET_PROMO_CODES_LOADING';
export const SET_PROMO_CODES = 'SET_PROMO_CODES';
export const SET_PROMO_CODE_LOADING = 'SET_PROMO_CODE_LOADING';
export const SET_PROMO_CODE = 'SET_PROMO_CODE';
export const SET_CREATE_PROMO_CODE_LOADING = 'SET_CREATE_PROMO_CODE_LOADING';
export const SET_UPDATE_PROMO_CODE_LOADING = 'SET_UPDATE_PROMO_CODE_LOADING';

const setPromoCodesLoading = dispatch => {
  return dispatch({ type: SET_PROMO_CODES_LOADING });
};

const setPromoCodes = (dispatch, payload) => {
  return dispatch({ type: SET_PROMO_CODES, payload });
};

const loadPromoCodes = async (dispatch, params) => {
  setPromoCodesLoading(dispatch, params);
  try {
    const data = await ApiActions.getPromoCodes(params);
    setPromoCodes(dispatch, { data });
  } catch (e) {
    throw e;
  }
};
const setPromoCodeLoading = dispatch => {
  return dispatch({ type: SET_PROMO_CODE_LOADING });
};

const setPromoCode = (dispatch, payload) => {
  return dispatch({ type: SET_PROMO_CODE, payload });
};

const loadPromoCode = async (dispatch, params) => {
  setPromoCodeLoading(dispatch, params);
  try {
    const data = await ApiActions.getPromoCodeById(params);
    setPromoCode(dispatch, { data });
    return data;
  } catch (e) {
    throw e;
  }
};
const setCreatePromoCodeLoading = (dispatch, params = true) => {
  return dispatch({ type: SET_CREATE_PROMO_CODE_LOADING, params });
};

const createPromoCode = async (dispatch, params) => {
  setCreatePromoCodeLoading(dispatch);

  try {
    const promoCode = await ApiActions.createPromoCode(params);
    setCreatePromoCodeLoading(dispatch, false);
    return promoCode;
  } catch (e) {
    setCreatePromoCodeLoading(dispatch, false);
    throw e;
  }
};

const setUpdatePromoCodeLoading = (dispatch, params = true) => {
  return dispatch({ type: SET_UPDATE_PROMO_CODE_LOADING, params });
};

const updatePromoCode = async (dispatch, params) => {
  setUpdatePromoCodeLoading(dispatch);
  try {
    const promoCode = await ApiActions.updatePromoCode(params);
    setUpdatePromoCodeLoading(dispatch, false);
    return promoCode;
  } catch (e) {
    setUpdatePromoCodeLoading(dispatch, false);
    throw e;
  }
};

export const actions = {
  loadPromoCodes,
  loadPromoCode,
  createPromoCode,
  updatePromoCode,
}
